import moment from "moment";
import Config, { autoPayStatusConfig, autoPayStatuses, beneficiaryStatusWithStyle, foodItemCategories, inventoryUnits, moveOutReasons, transferStatusWithStyle } from "./Config";
import { SlCalender, SlCreditCard } from "react-icons/sl";
import { GrVmMaintenance, GrTechnology } from "react-icons/gr";
import { GoCreditCard } from "react-icons/go";
import { HiOutlineComputerDesktop } from "react-icons/hi2";
import { GiExpense } from "react-icons/gi";
import { IoFastFoodOutline, IoKeyOutline } from "react-icons/io5";
import { GrShieldSecurity } from "react-icons/gr";
import { FaExclamationCircle, FaBolt, FaFileAlt, FaRunning, FaHouseDamage, FaCandyCane, FaBroom, FaBoxOpen, FaCookieBite } from "react-icons/fa";
import { toast } from "react-toastify";
import Images from "./Images";
import { CiMoneyCheck1, CiWifiOn } from "react-icons/ci";
import { MdOutlineGasMeter, MdOutlineLocalLaundryService } from "react-icons/md";
import { PiBroom } from "react-icons/pi";
import {
  FaLeaf, FaEgg,
  FaFlask, FaMugSaucer, FaFish,
  FaUtensils, FaBox,
  FaCompactDisc,
  FaNutritionix,
  FaBasketShopping,
  FaKitchenSet,
  FaCakeCandles
} from "react-icons/fa6";

export function compressAmount(amount) {
  if (amount >= 10000000) {
    return "₹" + (amount / 10000000).toFixed(1) + " Cr";
  } else if (amount >= 100000) {
    return "₹" + (amount / 100000).toFixed(1) + " L";
  } else {
    return "₹" + amount?.toString();
  }
}

export function getModeName(type) {
  if (Number(type) === 1) return "CASH";
  else if (Number(type) === 2) return "UPI";
  else if (Number(type) === 3) return "NET BANKING";
  else if (Number(type) === 4) return "CARD";
  else if (Number(type) === 5) return "SEC ADJUSTED";
  else return "UPI";
}

export function getNatureName(type) {
  if (Number(type) === 1) return "Operating";
  else if (Number(type) === 2) return "Asset Investment";
  else return "Operating";
}

export function getLeadRentRange(type) {
  if (Number(type) == Config.RENT_RANGE.ZERO_TO_FIVE_K) return "0-5K";
  else if (Number(type) == Config.RENT_RANGE.FIVE_TO_TEN_K) return "5K-10K";
  else if (Number(type) == Config.RENT_RANGE.TEN_TO_FIFTEEN_K) return "10K-15K";
  else if (Number(type) == Config.RENT_RANGE.FIFTEEN_TO_TWENTY_K)
    return "15K-20K";
  else if (Number(type) == Config.RENT_RANGE.TWENTY_TO_TWENTY_FIVE_K)
    return "20K-25K";
  else if (Number(type) == Config.RENT_RANGE.TWENTY_FIVE_TO_THIRTY_K)
    return "25K-30K";
  else if (Number(type) == Config.RENT_RANGE.THIRTY_TO_THIRTY_FIVE_K)
    return "30K-35K";
  else if (Number(type) == Config.RENT_RANGE.THIRTY_FIVE_TO_FORTY_K)
    return "35K-40K";
  else if (Number(type) == Config.RENT_RANGE.FORTY_TO_FORTY_FIVE_K)
    return "40K-45K";
  else if (Number(type) == Config.RENT_RANGE.FORTY_FIVE_TO_FIFTY_K)
    return "45K-50K";
  else return "50K+";
}

export function getLeadSource(type) {
  if (Number(type) === Config.SOURCE.FACEBOOK) return "Facebook";
  else if (Number(type) === Config.SOURCE.GOOGLE) return "Google";
  else if (Number(type) === Config.SOURCE.INSTAGRAM) return "Instagram";
  else if (Number(type) === Config.SOURCE.FLATMATE) return "Flatmate.in";
  else if (Number(type) === Config.SOURCE.WALKIN) return "Walk In";
  else if (Number(type) === Config.SOURCE.WEBSITE) return "Website";
  else if (Number(type) === Config.SOURCE.ACRES) return "99acres";
  else if (Number(type) === Config.SOURCE.WEBSITE) return "Website";
  else if (Number(type) === Config.SOURCE.EQARO) return "Eqaro";
  else if (Number(type) === Config.SOURCE.NOBROKER) return "NoBroker";
  else if (Number(type) === Config.SOURCE.OLX) return "Olx";
  else if (Number(type) === Config.SOURCE.QUIKR) return "Quikr";
  else if (Number(type) === Config.SOURCE.MAGICBRICKS) return "Magic Bricks";
  else if (Number(type) === Config.SOURCE.HOUSING) return "Housing";
  else if (Number(type) === Config.SOURCE.OTHERS) return "Others";
  else return "Others";
}

export function capitalizeFirstLetter(str) {
  if (str === null || str === undefined) return "";
  return str
    .split(" ") // Split the string into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(" "); // Join the words back into a string
}

export const getFinancialYear = () => {
  const today = moment();
  const year = today.year();
  const month = today.month() + 1; // Months are 0-based in Moment.js

  let startYear, endYear;

  if (month >= 4) {
    // April to December
    startYear = year;
    endYear = year + 1;
  } else {
    // January to March
    startYear = year - 1;
    endYear = year;
  }

  return {
    startDate: moment(`${startYear}-04-01`, "YYYY-MM-DD").format("MMM,YY"),
    endDate: moment(`${endYear}-03-31`, "YYYY-MM-DD").format("MMM,YY"),
  };
};

export const getRole = (role) => {
  if (role === 1) return "Admin";
  else if (role === 2) return "Warden";
  else if (role === 3) return "Electrician";
  else if (role === 4) return "Plumber";
  else if (role === 5) return "Laundry";
  else if (role === 6) return "Carpenter";
  else if (role === 7) return "Partner";
  else if (role === 0) return "Client";
  else if (role === 8) return "Cook";
  else if (role === 9) return "House Keeping";
  else if (role === 10) return "Sales Person";
  else if (role === 11) return "Security Guard";
  else if (role === 12) return "Finance Admin";
  else if (role === 13) return "Back Office";
  else if (role === 14) return "Help Desk";
  else if (role === 15) return "Broker";
  else if (role === 16) return "Technician";
  else if (role === 17) return "Purifier Tech";
  else if (role === 18) return "Painter";
  else if (role === 19) return "Food Vendor";
  else if (role === Config.STAFF_ROLES.SALES_HEAD) return "Sales Head";
  else if (role === Config.STAFF_ROLES.SUPER_ADMIN) return "Super Admin";
  else if (role === Config.STAFF_ROLES.KITCHEN_MANAGER) return "Kitchen Manager";
  else if (role === Config.STAFF_ROLES.IT_ADMIN) return "IT Admin";
  else if (role === Config.STAFF_ROLES.BUS_INCHARGE) return "Bus Incharge";
  else if (role === Config.STAFF_ROLES.MAINTENANCE_SUPERVISOR) return "Maintenance Supervisor";
  else return "Staff";
};

export const getUserType = (user) => {
  if (user === 1) return "Client";
  else if (user === 2) return "Tenant";
  else if (user === 3) return "Staff";
  else if (user === 4) return "Vendor";
  else if (user === 5) return "Landlord";
  else return "Vendor";
};

export const truncateText = (text, maxLength) =>
  text.length > maxLength ? text.substring(0, maxLength) + "..." : text;

export const getDueIcon = (type) => {
  switch (type) {
    case Config.dueType.RENT:
      return <SlCalender className="w-3 h-3" />;
    case Config.dueType.SECURITY:
      return <GrShieldSecurity className="w-3 h-3" />;
    case Config.dueType.MAINTENANCE:
      return <GrVmMaintenance className="w-3 h-3" />;
    case Config.dueType.ELECTRICITY:
      return <FaBolt className="w-3 h-3" />;
    case Config.dueType.REGISTRATION:
      return <GoCreditCard className="w-3 h-3" />;
    case Config.dueType.TECH_CHARGES:
      return <HiOutlineComputerDesktop className="w-3 h-3" />;
    case Config.dueType.OTHER:
      return <GiExpense className="w-3 h-3" />;
    case Config.dueType.AGREEMENT_CHARGE:
      return <FaFileAlt className="w-3 h-3" />;
    case Config.dueType.FOOD:
      return <IoFastFoodOutline className="w-3 h-3" />;
    case Config.dueType.FINE:
      return <CiMoneyCheck1 className="w-3 h-3" />;
    case Config.dueType.MOVE_OUT_CHARGES:
      return <FaRunning className="w-3 h-3" />;
    case Config.dueType.WIFI:
      return <CiWifiOn className="w-3 h-3" />;
    case Config.dueType.GAS:
      return <MdOutlineGasMeter className="w-3 h-3" />;
    case Config.dueType.MAID_CHARGES:
      return <PiBroom className="w-3 h-3" />;
    case Config.dueType.DAMAGE:
      return <FaHouseDamage className="w-3 h-3" />;
    case Config.dueType.KEY_CHARGES:
      return <IoKeyOutline className="w-3 h-3" />;
    case Config.dueType.LAUNDRY_CHARGES:
      return <MdOutlineLocalLaundryService className="w-3 h-3" />;
    default:
      return <FaExclamationCircle className="w-3 h-3" />;
  }
};

export function addDays(date, days) {
  const newDate = new Date(date);
  newDate.setDate(date.getDate() + days);
  return newDate;
}

// export function handleCopy (numberToCopy) {
//   navigator.clipboard.writeText(numberToCopy)
//     .then(() => toast.success("Copied 👍"))
//     .catch(err => toast.error('Failed to copy'));
// };

export function handleCopy(numberToCopy) {
  const textToCopy = String(numberToCopy || "");

  if (!textToCopy) {
    toast.error("Nothing to copy");
    return;
  }

  // Modern approach with fallback
  if (navigator.clipboard?.writeText) {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => toast.success("Copied to clipboard"))
      .catch(() => copyUsingFallback(textToCopy));
  } else {
    copyUsingFallback(textToCopy);
  }
}

function copyUsingFallback(text) {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  document.body.appendChild(textArea);
  textArea.select();

  try {
    document.execCommand("copy");
    toast.success("Copied to clipboard");
  } catch (err) {
    toast.error("Failed to copy. Please select and copy manually.");
  } finally {
    document.body.removeChild(textArea);
  }
}

export const generateMonthOptions = Array.from({ length: 12 }, (_, i) => ({
  label: `${i + 1} month${i > 0 ? "s" : ""}`,
  value: i + 1,
}));

export const paymentModes = [
  {
    value: 1,
    label: "Cash",
    icon: <img src={Images.Offline} alt="Offline" className="w-10 h-10" />,
  },
  {
    value: 2,
    label: "UPI",
    icon: <img src={Images.UPI} alt="UPI" className="w-10 h-10" />,
  },
  {
    value: 3,
    label: "Net Banking",
    icon: (
      <img src={Images.NetBanking} alt="Net Banking" className="w-10 h-10" />
    ),
  },
  {
    value: 4,
    label: "Card",
    icon: <img src={Images.Card} alt="Card" className="w-10 h-10" />,
  },
];

export const natureExpensesModes = [
  {
    value: 1,
    label: "Operating",
  },
  {
    value: 2,
    label: "Asset Investment",
  },
];

export const getMoveOutReasonLabel = (value) => {
  const reason = moveOutReasons.find(item => item.value === value);
  return reason ? reason.label : "End of Lease / Contract"; // fallback to value if label not found
};

export const hasPermission = (key, user) => {
  if (user?.userType === Config.USER_TYPE.CLIENT ||
    user?.role === Config.STAFF_ROLES.PARTNER)
    return true;
  const bit = Config.PERMISSIONS[key];
  return (user?.permissions & (1 << bit)) !== 0;
};

export const PERMISSION_ROUTE_MAP = [
  // 👇 Tenants Module
  { permission: "MANANGE_TENANTS", route: "/tenants/active" },

  // 👇 Collections, Dues, Expenses (Finance Module)
  { permission: "MANANGE_COLLECTIONS", route: "/finance/collections" },
  { permission: "MANANGE_DUES", route: "/finance/dues" },
  { permission: "MANANGE_EXPENSES", route: "/finance/expenses" },

  // 👇 Properties Module
  { permission: "MANANGE_INVENTORY", route: "/property-list" },
  { permission: "MANANGE_EXTRACHARGES", route: "/extracharges" },

  // 👇 Agreements / Landlords / Lease
  { permission: "MANANGE_LANDLORD", route: "/landlords" },

  // 👇 Complaints
  { permission: "MANANGE_COMPLAINTS", route: "/complaints" },

  // 👇 Reports
  { permission: "MANANGE_REPORTS", route: "/reports" },

  { permission: "MANAGE_DOCUMENTS", route: "/documents-vault" },

  // 👇 Leads & Quick Actions
  { permission: "MANANGE_LEADS", route: "/leads" },
  { permission: "MANANGE_STAFF", route: "/staffs" },
  { permission: "MANANGE_SENDNOTICES", route: "/notice" },
  { permission: "MANANGE_REQUESTS", route: "/requests" },

  // 👇 Property Asset Management
  { permission: "MANANGE_PROPERTY_ASSETS", route: "/assets" }, // NEW

  // 👇 Default Dashboard for all clients/admins
  { permission: "VIEW_DASHBOARD", route: "/dashboard" },
];

export const getDueTypeLabel = (value) => {
  const entries = Object.entries(Config.dueType);

  const found = entries.find(([_, v]) => v === value);

  if (!found) return "Other";

  const key = found[0];

  return key
    .replace(/_/g, " ");
  //.toLowerCase()
  //.replace(/\b\w/g, (c) => c.toUpperCase());
};

export const getDueLabel = (type) => {
  switch (type) {
    case Config.dueType.RENT:
      return "Rent";
    case Config.dueType.SECURITY:
      return "Security";
    case Config.dueType.MAINTENANCE:
      return "Maintenance";
    case Config.dueType.ELECTRICITY:
      return "Electricity";
    case Config.dueType.REGISTRATION:
      return "Registration";
    case Config.dueType.TECH_CHARGES:
      return "Tech Charges";
    case Config.dueType.OTHER:
      return "Other";
    case Config.dueType.AGREEMENT_CHARGE:
      return "Agreement Charge";
    case Config.dueType.FOOD:
      return "Food";
    case Config.dueType.FINE:
      return "Fine";
    case Config.dueType.SETTLEMENT:
      return "Settlement";
    case Config.dueType.WIFI:
      return "Wifi";
    case Config.dueType.GAS:
      return "Gas";
    case Config.dueType.MAID_CHARGES:
      return "Maid Charges";
    case Config.dueType.DAMAGE:
      return "Damage";
    case Config.dueType.KEY_CHARGES:
      return "Key Charges";
    case Config.dueType.LAUNDRY_CHARGES:
      return "Laundry Charges";
    case Config.dueType.MOVE_OUT_CHARGES:
      return "MoveOut Charges";
    case Config.dueType.GUEST_CHARGES:
      return "Guest Charges";
    case Config.dueType.BUS_CHARGES:
      return "Bus Charges";
    default:
      return "Other";
  }
};

export const getLandlordTransactionFor = (item) => {
  if (item.type === 1) {
    return "Rent";
  } else if (item.type === 43) {
    return "Security";
  } else if (item.type === 5) {
    return "Maintenance";
  } else {
    return "Others";
  }
};

export const getPercentageChange = (current, previous) => {
  if (previous === 0 && current === 0) return 0;
  if (previous === 0) return 100;
  return Math.round(((current - previous) / previous) * 100);
};

export const getDeltaUI = (value, intent = "positive") => {
  if (value === 0) {
    return { text: "→ 0%", className: "text-gray-500" };
  }

  const isIncrease = value > 0;
  const absValue = Math.abs(value);

  // Positive metric (Revenue, Occupancy, Resolution)
  if (intent === "positive") {
    return isIncrease
      ? { text: `↑ ${absValue}%`, className: "text-green-600" }
      : { text: `↓ ${absValue}%`, className: "text-red-600" };
  }

  // Negative metric (Moving Out, Complaints, Revenue Loss)
  return isIncrease
    ? { text: `↑ ${absValue}%`, className: "text-red-600" }
    : { text: `↓ ${absValue}%`, className: "text-green-600" };
};

export const format2Decimals = (value) =>
  Number.isFinite(Number(value))
    ? Number(value).toFixed(2)
    : "0.00";

export const formatAmount = (value) =>
  Number(value || 0).toLocaleString("en-IN");

export const paymentModesType = [
  {
    value: 1,
    label: "Cash",
    icon: <img src={Images.Offline} alt="Offline" className="w-10 h-10" />,
  },
  {
    value: 2,
    label: "UPI",
    icon: <img src={Images.UPI} alt="UPI" className="w-10 h-10" />,
  },
  {
    value: 3,
    label: "Net Banking",
    icon: (
      <img src={Images.NetBanking} alt="Net Banking" className="w-10 h-10" />
    ),
  },
  {
    value: 4,
    label: "Card",
    icon: <img src={Images.Card} alt="Card" className="w-10 h-10" />,
  },
  {
    value: 0,
    label: "Kipinn App",
    icon: <img src={Images.Logo} alt="Card" className="w-10 h-10" />,
  },
  {
    value: 5,
    label: "Sec Adjusted",
    icon: <img src={Images.Offline} alt="Card" className="w-10 h-10" />,
  },
];

export const maskAccount = (acc) => {
  if (!acc) return "XXXX";
  const str = acc.toString();
  return "XXXX" + str.slice(-4);
};

export const getOrdinalNumber = (n) => {
  if (n > 3 && n < 21) return n + "th";
  switch (n % 10) {
    case 1:
      return n + "st";
    case 2:
      return n + "nd";
    case 3:
      return n + "rd";
    default:
      return n + "th";
  }
};

export const allDocumentTypes = [
  { key: 1, label: "Aadhaar Card" },
  { key: 2, label: "Aadhaar Card Back" },
  { key: 3, label: "Pan Card" },
  { key: 7, label: "Student/Employer Id" },
  { key: 6, label: "Police Verification" },
  { key: 5, label: "Rent Agreement" },
  { key: 4, label: "Tenant Photo" },
  { key: 11, label: "Rental Bond" },
  { key: 13, label: "Cancelled Cheque" },
  { key: 14, label: "Settlement Summary" },
  { key: 15, label: "Consent Form" },
  { key: 16, label: "CVIRMS" },
  { key: 50, label: "Others" }
];

export const getStatusConfig = (value) => {
  const status = beneficiaryStatusWithStyle.find(item => item.value === value);
  return status || {
    label: "Unknown",
    color: "bg-gray-100 text-gray-700 border-gray-200",
    dotColor: "bg-gray-500"
  };
};

export const getTransferStatusConfig = (value) => {
  const status = transferStatusWithStyle.find(item => item.value === value);
  return status || {
    label: "Unknown",
    color: "bg-gray-100 text-gray-700 border-gray-200",
    dotColor: "bg-gray-500"
  };
};

export const getAutoPayStatusConfig = (value) => {
  const status = autoPayStatusConfig[value];
  return status || {
    label: "Unknown",
    color: "bg-gray-100 text-gray-700 border-gray-200",
  };
}

export const complaintCategories = [
  { value: "Emergency Issues", label: "Emergency Issues" },
  { value: "Wi-Fi/Internet Issue", label: "Wi-Fi/Internet Issue" },
  { value: "Electronics/Appliance Issue", label: "Electronics/Appliance Issue" },
  { value: "Maintenance and infrastructure", label: "Maintenance and infrastructure" },
  { value: "Plumbing Issues", label: "Plumbing Issues" },
  { value: "AC Issue", label: "AC Issue" },
  { value: "Water Purifier Issue", label: "Water Purifier Issue" },
  { value: "Roommate and Co-Resident Issues", label: "Roommate and Co-Resident Issues" },
  { value: "Hygiene and Cleanliness", label: "Hygiene and Cleanliness" },
  { value: "Security and Privacy", label: "Security and Privacy" },
  { value: "Food and Meal", label: "Food and Meal" },
  { value: "Rent/Payment", label: "Rent/Payment" },
  { value: "Staff", label: "Staff" },
  { value: "Other", label: "Other" },
];

export const gracePeriod = [
  { label: "3 days", value: 3 },
  { label: "5 days", value: 5 },
  { label: "7 days", value: 7 },
  { label: "11 days", value: 11 },
];

// Helper function to get category label
export const getFoodCategoryLabel = (categoryId) => {
  const category = foodItemCategories.find(cat => cat.value === categoryId);
  return category?.label || 'Unknown';
};

// Helper function to get unit label from unitType
export const getFoodUnitLabel = (unitType) => {
  const unit = inventoryUnits.find(u => u.value === unitType);
  return unit?.label || 'Unknown';
};



// Helper function to get stock status
export const getStockStatus = (currentCount) => {
  if (currentCount === 0) {
    return { label: 'Out of Stock', color: 'text-red-600', bg: 'bg-red-50' };
  } else if (currentCount < 5) {
    return { label: 'Low Stock', color: 'text-yellow-600', bg: 'bg-yellow-50' };
  } else {
    return { label: 'In Stock', color: 'text-green-600', bg: 'bg-green-50' };
  }
};

// Helper function to get category icon
export const getCategoryIcon = (categoryId) => {
  switch (categoryId) {
    case Config.FOOD_ITEM_CATEGORY.GRAINS:
      return <FaLeaf className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.PULSES:
      return <FaCompactDisc className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.VEGETABLES:
      return <FaNutritionix className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.FRUITS:
      return <FaBasketShopping className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.EGGS_DAIRY:
      return <FaEgg className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.OIL_GHEE:
      return <FaFlask className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.SPICES:
      return <FaKitchenSet className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.TEA_COFFEE:
      return <FaMugSaucer className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.MEAT_SEAFOOD:
      return <FaFish className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.SWEETENERS:
      return <FaCandyCane className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.BAKING:
      return <FaCakeCandles className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.CLEANING:
      return <FaBroom className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.PACKAGING:
      return <FaBoxOpen className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.KITCHEN:
      return <FaKitchenSet className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.SNACKS:
      return <FaCookieBite className="text-primary-color" />;
    case Config.FOOD_ITEM_CATEGORY.OTHERS:
      return <FaUtensils className="text-primary-color" />;
    default:
      return <FaBox className="text-gray-600" />;
  }
};
